import React, { useEffect, useState, useMemo } from 'react';
import { getSupabaseClient } from '../../lib/supabase';
import SupportChatModal from './SupportChatModal';

export default function SupportButton() {
  const [showChat, setShowChat] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const supabase = useMemo(() => getSupabaseClient(), []);

  useEffect(() => {
    if (showChat) return; // don't poll while chat is open

    let cancelled = false;

    const fetchUnread = async () => {
      try {
        const { data } = await supabase
          .from('support_conversations')
          .select('user_unread_count')
          .single();

        if (!cancelled && data) {
          setUnreadCount(data.user_unread_count ?? 0);
        }
      } catch {
        // No conversation yet
      }
    };

    fetchUnread();
    const intervalId = setInterval(fetchUnread, 30000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [supabase, showChat]);

  const handleClose = () => {
    setShowChat(false);
    setUnreadCount(0);
  };

  if (showChat) {
    return <SupportChatModal onClose={handleClose} />;
  }

  return (
    <button
      type="button"
      onClick={() => setShowChat(true)}
      className="fixed bottom-20 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#304031] text-[#FEF6D6] shadow-lg hover:bg-[#304031]/90 transition-colors"
      aria-label="Support chat"
    >
      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
